import checkmarkIcon from '@SvgIcon/checkmark-circled.svg'

import svgIconHtml from '../../../shared/svgIconHtml'

export default {
  name: 'Step',

  // language=HTML
  template: `
    <div class="ui-step" :class="rootClasses">
      <div v-if="completed" class="ui-step__icon is-icon">
        ${svgIconHtml(checkmarkIcon)}
      </div>
      <div v-else class="ui-step__icon is-text">
        {{ index + 1 }}
      </div>
      <div class="ui-step__title">
        <slot>{{ title }}</slot>
      </div>
      <div v-if="$slots.description" class="ui-step__description">
        <slot name="description"></slot>
      </div>
    </div>
  `,

  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      index: 0,
    }
  },

  computed: {
    active() {
      return this.index === this.$parent.modelValue
    },

    completed() {
      return this.index < this.$parent.modelValue
    },

    rootClasses() {
      return {
        'is-incomplete': !this.completed,
        'is-complete': this.completed,
        'is-active': this.active,
      }
    },
  },

  methods: {
    setIndex(index) {
      this.index = index
    },
  },
}
